import React from 'react';
import { useAuth } from '@repo/common';

const BillingLogHeader = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'A';

  return (
    <div
      className='flex h-[40px] px-[30px] items-center gap-4 border-t border-b border-grayscale-gray02 bg-surface-lightgray40 w-full 
    typo-b13 text-text-secondary'
    >
      <div className='flex w-10 h-10 items-center justify-center' />
      <div
        className={`flex ${
          isAdmin ? 'max-w-[280px]' : 'max-w-[240px]'
        } w-full justify-start items-center gap-2.5`}
      >
        Issue
      </div>
      <div
        className={`flex ${
          isAdmin ? 'flex-1' : 'max-w-[220px] w-full'
        } justify-start items-center gap-2.5`}
      >
        Item
      </div>
      {isAdmin && (
        <div
          className={`flex max-w-[160px] justify-start items-center gap-2.5 w-full`}
        >
          Description
        </div>
      )}
    </div>
  );
};

export default BillingLogHeader;
